var quiz1Cat1 = [{
        "title":"What is the sum of 5+2?",
        "choices":["7","8","9","6"],
        "correctAnswer":0,
},
{
        "title":"What farm animal gives us milk to drink?",
        "choices":["Hen","Cow","Dog","Chicken"],
        "correctAnswer":1,
},
{
        "title":"Johnny had five pumpkins and he made two Jack-O-Lanterns. Out of the five, how many would there be left without a face?",
        "choices":["0","2","3","5"],
        "correctAnswer":2,
},
{
        "title":"5+5= what?",
        "choices":["0","8","10","5"],
        "correctAnswer":2,
},
{
        "title":" If you wanted to dig a hole, which of the following would you be most likely to use?",
        "choices":["Hoe","spade","hammer","nail"],
        "correctAnswer":1,
},
{
        "title":" On a clock, if the big hand is on 12 and the little hand is on 3 what time would it be?",
        "choices":["3'o clock","5'o clock","2'o clock","4'o clock"],
        "correctAnswer":0,
},
{
        "title":" If an average person counted all of their fingers and toes, how many would they have?",
        "choices":["24","20","28","19"],
        "correctAnswer":1,
},
{
        "title":" What colors would you use to make the color purple?",
        "choices":["Red and pink","pink and yellow","red and blue","blue and pink"],
        "correctAnswer":2,
},
{
        "title":" What is 10-2?",
        "choices":["6","7","5","8"],
        "correctAnswer":3,
},
{
        "title":" What vehicle runs on a track and blows a whistle?",
        "choices":["train","helicopter","Aeroplane","Car"],
        "correctAnswer":0,
},
{
        "title":" What holds school supplies and children also carry them on their backs?",
        "choices":["paper bag","Box","school bag","Purse"],
        "correctAnswer":0,
},
{
        "title":" What colour starts with the letter “G”?",
        "choices":["Green"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":" What comes after the number five?",
        "choices":["6"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" How many fingers do you have in one hand??",
        "choices":["Five fingers"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" What do you drink that comes from a cow?",
        "choices":["Milk"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" What part of your body lets you see",
        "choices":["Eyes"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":"  How many months do we have in a year?",
        "choices":["12 Months"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":"What is 2+2?",
        "choices":["4"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" What are your ears for?",
        "choices":["listening/hearing"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":"Which day comes after Friday?",
        "choices":["saturday"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"We use our eyes to?",
        "choices":[" See"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"We smell with our?",
        "choices":["Nose"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"  Baby of a dog is called",
        "choices":["Puppy"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"What do you call a baby cow?",
        "choices":["Calf"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
]
var quiz1Cat2 = [
{
        "title":" How many days do we have in a week?",
        "choices":["seven"],
        "correctAnswer":0,
},
{
        "title":"How many days are there in a normal year?",
        "choices":["365"],
        "correctAnswer":0,
},
{
        "title":"How many colours are there in a rainbow?",
        "choices":["seven"],
        "correctAnswer":0,
},
{
        "title":" which animal is known as ship of desert ",
        "choices":["Camel"],
        "correctAnswer":0,
},
{
        "title":"How many letters are there in english alphabet?",
        "choices":["26"],
        "correctAnswer":0,
},
{
        "title":"How many consonants are there in english alphabet>",
        "choices":["21"],
        "correctAnswer":0,
},
{
        "title":"How many sides are there in a triangle? ",
        "choices":["Three"],
        "correctAnswer":0,
},
{
        "title":"Which month of the year has least number of days",
        "choices":["February"],
        "correctAnswer":0,
},
{
        "title":"Which vowels are there in english alphabet series?",
        "choices":["A, e, i, o, u"],
        "correctAnswer":0,
},
{
        "title":"Which animal is called the king of jungle?",
        "choices":["Lion"],
        "correctAnswer":0,
},
{
        "title":"How many primary colors are there?",
        "choices":["three- red, yellow, blue"],
        "correctAnswer":0,
},
{
        "title":"How many days are there in a month of february in a leap year?",
        "choices":["29 days"],
        "correctAnswer":0,
},
{
        "title":"What do you call a house made of ice",
        "choices":["Igloo"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest animal on earth?",
        "choices":["Blue Whale"],
        "correctAnswer":0,
},
{
        "title":"Which is tallest animal on earth?",
        "choices":["girrafe"],
        "correctAnswer":0,
},
{
        "title":"What is the top color in a rainbow?",
        "choices":["Red"],
        "correctAnswer":0,
},
{
        "title":"Which animals lays the largest egg?",
        "choices":["Ostrich"],
        "correctAnswer":0,
},
{
        "title":"Which city is the statue of liberty in?",
        "choices":["New york city"],
        "correctAnswer":0,
},
{
        "title":"Name first three planet in our solar system",
        "choices":["Mercury, venu, earth"],
        "correctAnswer":0,
},
{
        "title":" what is 5x 5?",
        "choices":["25"],
        "correctAnswer":0,
},
{
        "title":"Seoul is the capital city of which country?",
        "choices":["South Korea"],
        "correctAnswer":0,
},
{
        "title":"Name three countries on the continent of africa",
        "choices":["Senegal, Ghana and Nigeria"],
        "correctAnswer":0,
},
{
        "title":"Which country are the Giza Pyramids in?",
        "choices":["The Giza Pyramids are in Egypt"],
        "correctAnswer":0,
},
{
        "title":"Which planet is known as the Red Planet?",
        "choices":["Mars"],
        "correctAnswer":0,
},
{
        "title":"How many sense organs do we have?",
        "choices":["5"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest sense organ?",
        "choices":["Skin"],
        "correctAnswer":0,
},
]
var quiz1Cat3 = [
{
        "title":"How many sides does an octagon have?",
        "choices":["8"],
        "correctAnswer":0,
},
{
        "title":"What is the capital of Germany?",
        "choices":["Berlin"],
        "correctAnswer":0,
},
{
        "title":"What is the fastest Land animal?",
        "choices":["Cheetah"],
        "correctAnswer":0,
},
{
        "title":"Where is Eiffel Tower Located?",
        "choices":["Paris"],
        "correctAnswer":0,
},
{
        "title":"What is thhe largest animal in the ocean",
        "choices":["Whale"],
        "correctAnswer":0,
},
{
        "title":"Where is Eiffel Tower Located?",
        "choices":["Paris"],
        "correctAnswer":0,
},
{
        "title":"What do you call a baby kangaroo?",
        "choices":["Joeys"],
        "correctAnswer":0,
},
{
        "title":"What do you call a group of sheep?",
        "choices":["Flock"],
        "correctAnswer":0,
},
{
        "title":"How many legs does a spider have?",
        "choices":["Eight"],
        "correctAnswer":0,
},
{
        "title":" How many continents are there in the world?",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"What is the smallest country in the world?",
        "choices":["Vatican City"],
        "correctAnswer":0,
},
{
        "title":"What’s the capital city of Spain?",
        "choices":["Madrid"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest planet in solar system?",
        "choices":["Jupiter"],
        "correctAnswer":0,
},
{
        "title":"What Gas do we breathe?",
        "choices":["Oxygen"],
        "correctAnswer":0,
},
{
        "title":"Which animal has black and white stripe?",
        "choices":["Zebra"],
        "correctAnswer":0,
},
{
        "title":"What is the sum of 10 + 8?",
        "choices":["18"],
        "correctAnswer":0,
},
{
        "title":"Which color traffic signal indicates to stop?",
        "choices":["Red"],
        "correctAnswer":0,
},
{
        "title":"Which color traffic signal indicates to get ready?",
        "choices":["Orange"],
        "correctAnswer":0,
},
{
        "title":"Which color traffic signal indicates to go?",
        "choices":["Green"],
        "correctAnswer":0,
},
{
        "title":"How many days are there in a week?",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"What is the capital of USA?",
        "choices":["Washington DC"],
        "correctAnswer":0,
},
{
        "title":"Which is largest hot desert in the world?",
        "choices":["Sahara Dessert"],
        "correctAnswer":0,
},
{
        "title":"If you freeze water, what do you get?",
        "choices":["Ice"],
        "correctAnswer":0,
},
{
        "title":"What do bees make?",
        "choices":["Honey"],
        "correctAnswer":0,
},
{
        "title":"Which planet in solar system have rings?",
        "choices":["Saturn"],
        "correctAnswer":0,
},
{
        "title":"In which direction does sun sets?",
        "choices":["West"],
        "correctAnswer":0,
},
{
        "title":"How many minutes are there in one hour?",
        "choices":["60 minutes"],
        "correctAnswer":0,
},
{
        "title":"How many seconds are there in one minute?",
        "choices":["60"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest ocean in the world?",
        "choices":["Pacific ocean"],
        "correctAnswer":0,
},
{
        "title":"Your Mother’s father is your?",
        "choices":["Grand Father"],
        "correctAnswer":0,
},
{
        "title":"Birds fly with their?",
        "choices":["Wings"],
        "correctAnswer":0,
},
{
        "title":". How many sides does a square have?",
        "choices":["four"],
        "correctAnswer":0,
},
{
        "title":"How many colours are there in a rainbow",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest country in the world by area?",
        "choices":["Russia"],
        "correctAnswer":0,
},
{
        "title":"What is the female deer called?",
        "choices":["Doe"],
        "correctAnswer":0,
},
{
        "title":"What is the baby of a cat called",
        "choices":["Kitten"],
        "correctAnswer":0,
},
{
        "title":"How many faces does a cube have?",
        "choices":["Six"],
        "correctAnswer":0,
},
{
        "title":"Which is the third month of the year?",
        "choices":["March"],
        "correctAnswer":0,
},
{
        "title":"Which is the fourth day of the week?",
        "choices":["Thursday"],
        "correctAnswer":0,
},
{
        "title":"Which month comes after July?",
        "choices":["August"],
        "correctAnswer":0,
},
{
        "title":"Which is the last month of the year?",
        "choices":["December"],
        "correctAnswer":0,
},
{
        "title":"Which is the first month of the year?",
        "choices":["January"],
        "correctAnswer":0,
},
{
        "title":"After which Islamic month eid is celebrated?",
        "choices":["Ramadan"],
        "correctAnswer":0,
},
{
        "title":"What is the sum of 6 and 8?",
        "choices":["14"],
        "correctAnswer":0,
},
{
        "title":"Where do we get oxygen from?",
        "choices":["Plants and Trees"],
        "correctAnswer":0,
},
{
        "title":"Your Father’s mother will be your",
        "choices":["Grandmother"],
        "correctAnswer":0,
},
{
        "title":"Who makes the wooden furniture?",
        "choices":["Carpenter"],
        "correctAnswer":0,
},
{
        "title":".  How many days are there is February?",
        "choices":["28, 29 in a leap year"],
        "correctAnswer":0,
},
{
        "title":"Name a red color vegetable?",
        "choices":["Tomato"],
        "correctAnswer":0,
},
{
        "title":"How many emirates are there in UAE?",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"How many Millilitres makes one litre?",
        "choices":["1000"],
        "correctAnswer":0,
},
{
        "title":"How many grams makes 1 kilogram?",
        "choices":["1000 gram"],
        "correctAnswer":0,
},
{
        "title":"How many times does Muslim pray in a day?",
        "choices":["5"],
        "correctAnswer":0,
},
{
        "title":"What are the five pillars of Islam?",
        "choices":["Faith, Prayers, Alms, fasting, pilgrimage"],
        "correctAnswer":0,
},
{
        "title":"In which Hijri month is eid ul fitr celebrated?",
        "choices":["Shawwal"],
        "correctAnswer":0,
},
{
        "title":"In which Hijri month is eid Al Adha is celebrated?",
        "choices":["Dhul Hijjah"],
        "correctAnswer":0,
},
{
        "title":"If you mix red and yellow color, which color you will get?",
        "choices":["Orange"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Saudi Arabia?",
        "choices":["Riyadh"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Oman?",
        "choices":["Muscat"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Bahrain?",
        "choices":["Al Manama"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Kuwait?",
        "choices":["Kuwait City"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city Qatar?",
        "choices":["Doha"],
        "correctAnswer":0,
},
{
        "title":"Which of these lays egg: hen, cat, dog",
        "choices":["Hen"],
        "correctAnswer":0,
},
{
        "title":"Which organ helps us to see?",
        "choices":["Eyes"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to walk?",
        "choices":["Legs"],
        "correctAnswer":0,
},
{
        "title":"Which month comes after July?",
        "choices":["August"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to write?",
        "choices":["Hand"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to listen?",
        "choices":["Ears"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to smell?",
        "choices":["Nose"],
        "correctAnswer":0,
},
{
        "title":"Which one of these is a domestic animal? Cat, zebra, Giraffe",
        "choices":["Cat"],
        "correctAnswer":0,
},
{
        "title":"Which doctor do we visit when we have problem in our teeth?",
        "choices":["Dentist"],
        "correctAnswer":0,
},
{
        "title":"1. In which direction does the sunrise?",
        "choices":["East"],
        "correctAnswer":0,
},
{
        "title":"How many zeros are there in one hundred thousand?",
        "choices":["5"],
        "correctAnswer":0,
},
{
        "title":"How many hours are there in two days?",
        "choices":["48 hours (24+24)"],
        "correctAnswer":0,
},
{
        "title":"How many months of the year have 31 days?",
        "choices":["7 (January, March, May, July, August, October and December)"],
        "correctAnswer":0,
},
{
        "title":"How many weeks are there in one year?",
        "choices":["52"],
        "correctAnswer":0,
},
{
        "title":"Which are the colors in a rainbow?",
        "choices":["Violet, Indigo, Blue, Green, Yellow, Orange, Red"],
        "correctAnswer":0,
},
{
        "title":"How many bones does an adult human have?",
        "choices":["206"],
        "correctAnswer":0,
},
{
        "title":"Who was the first man to walk on the moon?",
        "choices":["Neil Amstrong"],
        "correctAnswer":0,
},
{
        "title":"How many millimeters are there in 1cm?",
        "choices":["10mm"],
        "correctAnswer":0,
},
{
        "title":"Which is the nearest star to planet earth?",
        "choices":["Sun"],
        "correctAnswer":0,
},
{
        "title":"Which is the longest river on the earth?",
        "choices":["Nile"],
        "correctAnswer":0,
},
{
        "title":"Which is the principal source of energy for earth?",
        "choices":["Sun"],
        "correctAnswer":0,
},
{
        "title":"How many lungs does the human body have?",
        "choices":["Two"],
        "correctAnswer":0,
},
{
        "title":"What is the standard taste of the water?",
        "choices":["Water is tasteless"],
        "correctAnswer":0,
},
{
        "title":"Which is the tallest mountain in the world?",
        "choices":["Mount Everest"],
        "correctAnswer":0,
},
{
        "title":"Which continent is known as ‘Dark’ continent?",
        "choices":["Africa"],
        "correctAnswer":0,
},
{
        "title":"Which planet is known as the Red Planet?",
        "choices":["Mars","Jupiter","Venus","Earth"],
        "correctAnswer":0,
},
{
        "title":"Which is the most sensitive organ in our body?",
        "choices":["Skin"],
        "correctAnswer":0,
},
{
        "title":"Which day is observed as World Environment Day?",
        "choices":["5 June"],
        "correctAnswer":0,
},
{
        "title":"How many years are there in a century?",
        "choices":["100"],
        "correctAnswer":0,
},
{
        "title":"Who invented the Computer?",
        "choices":["Charles Babbage"],
        "correctAnswer":0,
},
{
        "title":"How many players are there in a cricket team?",
        "choices":["11"],
        "correctAnswer":0,
},
{
        "title":"Which day is observed as World Literacy Day?",
        "choices":["8 September"],
        "correctAnswer":0,
},
{
        "title":"Which is the principal source of energy for earth?",
        "choices":["Sun"],
        "correctAnswer":0,
},
{
        "title":"Who is the inventor of Radio?",
        "choices":["Marconi"],
        "correctAnswer":0,
},
{
        "title":"Which place is known as the roof of the world?",
        "choices":["Tibet"],
        "correctAnswer":0,
},
{
        "title":"How many teeth does a healthy adult have including the wisdom teeth?",
        "choices":["32"],
        "correctAnswer":0,
},
{
        "title":"Which gas is most abundant in the earth’s atmosphere?",
        "choices":["Nitrogen"],
        "correctAnswer":0,
},
{
        "title":"Which is the continent with the most number of countries?",
        "choices":["Africa"],
        "correctAnswer":0,
},
{
        "title":"How many planets are there in our solar system?",
        "choices":["8"],
        "correctAnswer":0,
},
{
        "title":"Which is the hottest continent on Earth?",
        "choices":["Africa"],
        "correctAnswer":0,
},
{
        "title":"Which is the smallest continent in the world?",
        "choices":["Australia"],
        "correctAnswer":0,
},
{
        "title":"How many years are there in a millennium?",
        "choices":["1000"],
        "correctAnswer":0,
},
{
        "title":"Which country is home to the kangaroo?",
        "choices":["Australia"],
        "correctAnswer":0,
},
{
        "title":"Who painted the Mona Lisa?",
        "choices":["Leonardo Da Vinci"],
        "correctAnswer":0,
},
{
        "title":"Who invented the telephone?",
        "choices":["Alexander Graham Bell"],
        "correctAnswer":0,
},
{
        "title":"What does the Internet prefix WWW stand for?",
        "choices":["World Wide Web"],
        "correctAnswer":0,
},
{
        "title":"How much of Earth’s surface is covered by ocean?",
        "choices":["71%"],
        "correctAnswer":0,
},
{
        "title":"Who discovered Penicillin in 1928?",
        "choices":["Alexander Fleming"],
        "correctAnswer":0,
},
]
var quiz1Cat4 = [
{
        "title":"What do you call a type of shape that has five sides?",
        "choices":["Pentagon"],
        "correctAnswer":0,
},
{
        "title":"How many equal sides does an isosceles triangle have?",
        "choices":["2"],
        "correctAnswer":0,
},
{
        "title":"Which is the coldest location in the earth?",
        "choices":["East Antarctica"],
        "correctAnswer":0,
},
{
        "title":"Who discovered electricity?",
        "choices":["Benjamin Franklin"],
        "correctAnswer":0,
},
{
        "title":"Which is the most widely spoken language in the world?",
        "choices":["Mandarin (Chinese)"],
        "correctAnswer":0,
},
{
        "title":"Who is the inventor of Television?",
        "choices":["John Logie Baird"],
        "correctAnswer":0,
},
{
        "title":"Which two parts of the body continue to grow for your entire life?",
        "choices":["Nose and Ears"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest plateau in the world?",
        "choices":["Tibetan Plateau"],
        "correctAnswer":0,
},
{
        "title":"Which is the instrument used to measure Blood pressure?",
        "choices":["Sphygmomanometer"],
        "correctAnswer":0,
},
{
        "title":"What color symbolizes peace?",
        "choices":["White"],
        "correctAnswer":0,
},
{
        "title":"Who is the founder of Microsoft?",
        "choices":["Bill Gates"],
        "correctAnswer":0,
},
{
        "title":"During which year did World War I begin?",
        "choices":["1914"],
        "correctAnswer":0,
},
{
        "title":"Global warming is caused by the excess of which type of gas?",
        "choices":["Carbon dioxide"],
        "correctAnswer":0,
},
{
        "title":"What is the name of the biggest rain forest in the world?",
        "choices":["The Amazon"],
        "correctAnswer":0,
},
{
        "title":"Which instrument is used for measuring wind speed?",
        "choices":["Anemometer"],
        "correctAnswer":0,
},
{
        "title":"Which language is used by the computer to process data?",
        "choices":["Binary language"],
        "correctAnswer":0,
},
{
        "title":"What covers approximately 71% of the Earth’s surface: Land or water?",
        "choices":["Water"],
        "correctAnswer":0,
},
{
        "title":"Which is the hardest substance available on earth?",
        "choices":["Diamond"],
        "correctAnswer":0,
},
{
        "title":"Which is the first element on the periodic table of elements?",
        "choices":["Hydrogen"],
        "correctAnswer":0,
},
{
        "title":"What is the largest joint in the human body?",
        "choices":["Knee"],
        "correctAnswer":0,
},
{
        "title":"Which is the smallest bone in the human body?",
        "choices":["Stapes (Ear bone)"],
        "correctAnswer":0,
},
{
        "title":"WWhich instrument is used to measure Atmospheric Pressure?",
        "choices":["Barometer"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest continent in the world?",
        "choices":["Asia"],
        "correctAnswer":0,
},
{
        "title":"Who is the inventor of the electric Bulb?",
        "choices":["Thomas Alva Edison"],
        "correctAnswer":0,
},
{
        "title":"On whose memory Nobel Prize is awarded?",
        "choices":["Alfred Nobel"],
        "correctAnswer":0,
},
{
        "title":"Who is the first woman to go to space?",
        "choices":["Valentina Tereshkova"],
        "correctAnswer":0,
},
{
        "title":"What is HCl?",
        "choices":["Hydrochloric Acid"],
        "correctAnswer":0,
},
{
        "title":"What is currency of China?",
        "choices":["Renminbi"],
        "correctAnswer":0,
},
{
        "title":"Name 3 root vegetables?",
        "choices":["Beets, carrots, and radish are root vegetables."],
        "correctAnswer":0,
},
]
var quiz1Cat5 = [
{
        "title":"Who write the words to the UAE’s national anthem?",
        "choices":["Dr. Aref Al Sheikh in 1986."],
        "correctAnswer":0,
},
{
        "title":"Who is the current de jure president of the United Arab Emirates?",
        "choices":["Khalifa bin Zayed bin Sultan Al Nahyan"],
        "correctAnswer":0,
},
{
        "title":"Who was the first President of the United Arab Emirates?",
        "choices":["H. H. Sheikh Zayed bin Sultan Al Nahyan."],
        "correctAnswer":0,
},
{
        "title":"In the capital of the United Arab Emirates how many foreign embassies are located in Abu Dhabi?",
        "choices":["100"],
        "correctAnswer":0,
},
{
        "title":"‘Sheikh Zayed Grand Mosque’ located in which city of UAE?",
        "choices":["Abu Dhabi (capital of UAE)"],
        "correctAnswer":0,
},
{
        "title":"Who is president of the Dubai Civil Aviation Authority, CEO and founder of the Emirates Group?",
        "choices":["Sheikh Ahmed bin Saeed Al Maktoum."],
        "correctAnswer":0,
},
{
        "title":"The Emirates Group was founded in which year?",
        "choices":["100"],
        "correctAnswer":0,
},
{
        "title":"In the capital of the United Arab Emirates how many foreign embassies are located in Abu Dhabi?",
        "choices":["1985 in Dubai"],
        "correctAnswer":0,
},
{
        "title":"What is the capital of United Arab Emirates?",
        "choices":["Abu Dhabi"],
        "correctAnswer":0,
},
{
        "title":"What is the official languages of United Arab Emirates?",
        "choices":["Arabic"],
        "correctAnswer":0,
},
{
        "title":"United Arab Emirates hosts how many nationalities doing business, living, learning and touring the nation?",
        "choices":["More than 200"],
        "correctAnswer":0,
},
{
        "title":"Constitution of the United Arab Emirates provides for how many federal authorities?",
        "choices":["The Supreme Council, The President and the Vice-President, The Cabinet, The Federal National Council and The Federal Judiciary"],
        "correctAnswer":0,
},
{
        "title":"Which is the official religion in the United Arab Emirates?",
        "choices":["Islam"],
        "correctAnswer":0,
},
{
        "title":"UAE area is approximately how much of land?",
        "choices":["71,023.6sq km."],
        "correctAnswer":0,
},
{
        "title":"UAE Notes or bills are in the denomination of what?",
        "choices":["AED 5, 10, 20, 50, 100, 200, 500 and 1,000"],
        "correctAnswer":0,
},
{
        "title":"United Arab Emirates adopted the ‘7 Lines’ design as its logo for the next 50 years in which year?",
        "choices":["2020"],
        "correctAnswer":0,
},
{
        "title":"What is the UAE’s national anthem?",
        "choices":["Ishy Bilady"],
        "correctAnswer":0,
},
{
        "title":"United Arab Emirates first solar powered gas    set up at where?",
        "choices":["In Dubai"],
        "correctAnswer":0,
},
{
        "title":"National animal of United Arab Emirates is?",
        "choices":["Arabian Oryx"],
        "correctAnswer":0,
},
{
        "title":"Which is UAE’s highest peak Towering at 1,934 m above sea level?",
        "choices":["Burj Khalifa (828 meter). Opened in 4 January 2010"],
        "correctAnswer":0,
},
{
        "title":"Which is UAE’s highest peak Towering at 1,934 m above sea level?",
        "choices":["Jebel Jais"],
        "correctAnswer":0,
},
{
        "title":"What is the official UAE news agency of the UAE Government?",
        "choices":["Emirates News Agency (WAM)"],
        "correctAnswer":0,
},
{
        "title":"What is the currency of United Arab Emirates?",
        "choices":["Dirhams"],
        "correctAnswer":0,
},
]
var quiz2Cat1 = [
{
        "title":"What is the sum of 5+2?",
        "choices":["7","8","9","6"],
        "correctAnswer":0,
},
{
        "title":"What farm animal gives us milk to drink?",
        "choices":["Hen","Cow","Dog","Chicken"],
        "correctAnswer":1,
},
{
        "title":"Johnny had five pumpkins and he made two Jack-O-Lanterns. Out of the five, how many would there be left without a face?",
        "choices":["0","2","3","5"],
        "correctAnswer":2,
},
{
        "title":"5+5= what?",
        "choices":["0","8","10","5"],
        "correctAnswer":2,
},
{
        "title":" If you wanted to dig a hole, which of the following would you be most likely to use?",
        "choices":["Hoe","spade","hammer","nail"],
        "correctAnswer":1,
},
{
        "title":" On a clock, if the big hand is on 12 and the little hand is on 3 what time would it be?",
        "choices":["3'o clock","5'o clock","2'o clock","4'o clock"],
        "correctAnswer":0,
},
{
        "title":" If an average person counted all of their fingers and toes, how many would they have?",
        "choices":["24","20","28","19"],
        "correctAnswer":1,
},
{
        "title":" What colors would you use to make the color purple?",
        "choices":["Red and pink","pink and yellow","red and blue","blue and pink"],
        "correctAnswer":2,
},
{
        "title":" What is 10-2?",
        "choices":["6","7","5","8"],
        "correctAnswer":3,
},
{
        "title":" What vehicle runs on a track and blows a whistle?",
        "choices":["train","helicopter","Aeroplane","Car"],
        "correctAnswer":0,
},
{
        "title":" What holds school supplies and children also carry them on their backs?",
        "choices":["paper bag","Box","school bag","Purse"],
        "correctAnswer":0,
}
]
var all_quiz = [
{
        "title":" What colour starts with the letter “G”?",
        "choices":["Green"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":" What comes after the number five?",
        "choices":["6"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" How many fingers do you have in one hand??",
        "choices":["Five fingers"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" What do you drink that comes from a cow?",
        "choices":["Milk"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" What part of your body lets you see",
        "choices":["Eyes"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":"  How many months do we have in a year?",
        "choices":["12 Months"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":"What is 2+2?",
        "choices":["4"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":" What are your ears for?",
        "choices":["listening/hearing"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""        
},
{
        "title":"Which day comes after Friday?",
        "choices":["saturday"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"We use our eyes to?",
        "choices":[" See"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"We smell with our?",
        "choices":["Nose"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"  Baby of a dog is called",
        "choices":["Puppy"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":"What do you call a baby cow?",
        "choices":["Calf"],
        "correctAnswer":0,
        "pointerEvents":false,
        "secondsLeft":20,
        "AnsweredQue":""
},
{
        "title":" How many days do we have in a week?",
        "choices":["seven"],
        "correctAnswer":0,
},
{
        "title":"How many days are there in a normal year?",
        "choices":["365"],
        "correctAnswer":0,
},
{
        "title":"How many colours are there in a rainbow?",
        "choices":["seven"],
        "correctAnswer":0,
},
{
        "title":" which animal is known as ship of desert ",
        "choices":["Camel"],
        "correctAnswer":0,
},
{
        "title":"How many letters are there in english alphabet?",
        "choices":["26"],
        "correctAnswer":0,
},
{
        "title":"How many consonants are there in english alphabet>",
        "choices":["21"],
        "correctAnswer":0,
},
{
        "title":"How many sides are there in a triangle? ",
        "choices":["Three"],
        "correctAnswer":0,
},
{
        "title":"Which month of the year has least number of days",
        "choices":["February"],
        "correctAnswer":0,
},
{
        "title":"Which vowels are there in english alphabet series?",
        "choices":["A, e, i, o, u"],
        "correctAnswer":0,
},
{
        "title":"Which animal is called the king of jungle?",
        "choices":["Lion"],
        "correctAnswer":0,
},
{
        "title":"How many primary colors are there?",
        "choices":["three- red, yellow, blue"],
        "correctAnswer":0,
},
{
        "title":"How many days are there in a month of february in a leap year?",
        "choices":["29 days"],
        "correctAnswer":0,
},
{
        "title":"What do you call a house made of ice",
        "choices":["Igloo"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest animal on earth?",
        "choices":["Blue Whale"],
        "correctAnswer":0,
},
{
        "title":"Which is tallest animal on earth?",
        "choices":["girrafe"],
        "correctAnswer":0,
},
{
        "title":"What is the top color in a rainbow?",
        "choices":["Red"],
        "correctAnswer":0,
},
{
        "title":"Which animals lays the largest egg?",
        "choices":["Ostrich"],
        "correctAnswer":0,
},
{
        "title":"Which city is the statue of liberty in?",
        "choices":["New york city"],
        "correctAnswer":0,
},
{
        "title":"Name first three planet in our solar system",
        "choices":["Mercury, venu, earth"],
        "correctAnswer":0,
},
{
        "title":" what is 5x 5?",
        "choices":["25"],
        "correctAnswer":0,
},
{
        "title":"Seoul is the capital city of which country?",
        "choices":["South Korea"],
        "correctAnswer":0,
},
{
        "title":"Name three countries on the continent of africa",
        "choices":["Senegal, Ghana and Nigeria"],
        "correctAnswer":0,
},
{
        "title":"Which country are the Giza Pyramids in?",
        "choices":["The Giza Pyramids are in Egypt"],
        "correctAnswer":0,
},
{
        "title":"Which planet is known as the Red Planet?",
        "choices":["Mars"],
        "correctAnswer":0,
},
{
        "title":"How many sense organs do we have?",
        "choices":["5"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest sense organ?",
        "choices":["Skin"],
        "correctAnswer":0,
},
{
        "title":"How many sides does an octagon have?",
        "choices":["8"],
        "correctAnswer":0,
},
{
        "title":"What is the capital of Germany?",
        "choices":["Berlin"],
        "correctAnswer":0,
},
{
        "title":"What is the fastest Land animal?",
        "choices":["Cheetah"],
        "correctAnswer":0,
},
{
        "title":"Where is Eiffel Tower Located?",
        "choices":["Paris"],
        "correctAnswer":0,
},
{
        "title":"What is thhe largest animal in the ocean",
        "choices":["Whale"],
        "correctAnswer":0,
},
{
        "title":"Where is Eiffel Tower Located?",
        "choices":["Paris"],
        "correctAnswer":0,
},
{
        "title":"What do you call a baby kangaroo?",
        "choices":["Joeys"],
        "correctAnswer":0,
},
{
        "title":"What do you call a group of sheep?",
        "choices":["Flock"],
        "correctAnswer":0,
},
{
        "title":"How many legs does a spider have?",
        "choices":["Eight"],
        "correctAnswer":0,
},
{
        "title":" How many continents are there in the world?",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"What is the smallest country in the world?",
        "choices":["Vatican City"],
        "correctAnswer":0,
},
{
        "title":"What’s the capital city of Spain?",
        "choices":["Madrid"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest planet in solar system?",
        "choices":["Jupiter"],
        "correctAnswer":0,
},
{
        "title":"What Gas do we breathe?",
        "choices":["Oxygen"],
        "correctAnswer":0,
},
{
        "title":"Which animal has black and white stripe?",
        "choices":["Zebra"],
        "correctAnswer":0,
},
{
        "title":"What is the sum of 10 + 8?",
        "choices":["18"],
        "correctAnswer":0,
},
{
        "title":"Which color traffic signal indicates to stop?",
        "choices":["Red"],
        "correctAnswer":0,
},
{
        "title":"Which color traffic signal indicates to get ready?",
        "choices":["Orange"],
        "correctAnswer":0,
},
{
        "title":"Which color traffic signal indicates to go?",
        "choices":["Green"],
        "correctAnswer":0,
},
{
        "title":"How many days are there in a week?",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"What is the capital of USA?",
        "choices":["Washington DC"],
        "correctAnswer":0,
},
{
        "title":"Which is largest hot desert in the world?",
        "choices":["Sahara Dessert"],
        "correctAnswer":0,
},
{
        "title":"If you freeze water, what do you get?",
        "choices":["Ice"],
        "correctAnswer":0,
},
{
        "title":"What do bees make?",
        "choices":["Honey"],
        "correctAnswer":0,
},
{
        "title":"Which planet in solar system have rings?",
        "choices":["Saturn"],
        "correctAnswer":0,
},
{
        "title":"In which direction does sun sets?",
        "choices":["West"],
        "correctAnswer":0,
},
{
        "title":"How many minutes are there in one hour?",
        "choices":["60 minutes"],
        "correctAnswer":0,
},
{
        "title":"How many seconds are there in one minute?",
        "choices":["60"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest ocean in the world?",
        "choices":["Pacific ocean"],
        "correctAnswer":0,
},
{
        "title":"Your Mother’s father is your?",
        "choices":["Grand Father"],
        "correctAnswer":0,
},
{
        "title":"Birds fly with their?",
        "choices":["Wings"],
        "correctAnswer":0,
},
{
        "title":". How many sides does a square have?",
        "choices":["four"],
        "correctAnswer":0,
},
{
        "title":"How many colours are there in a rainbow",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"Which is the largest country in the world by area?",
        "choices":["Russia"],
        "correctAnswer":0,
},
{
        "title":"What is the female deer called?",
        "choices":["Doe"],
        "correctAnswer":0,
},
{
        "title":"What is the baby of a cat called",
        "choices":["Kitten"],
        "correctAnswer":0,
},
{
        "title":"How many faces does a cube have?",
        "choices":["Six"],
        "correctAnswer":0,
},
{
        "title":"Which is the third month of the year?",
        "choices":["March"],
        "correctAnswer":0,
},
{
        "title":"Which is the fourth day of the week?",
        "choices":["Thursday"],
        "correctAnswer":0,
},
{
        "title":"Which month comes after July?",
        "choices":["August"],
        "correctAnswer":0,
},
{
        "title":"Which is the last month of the year?",
        "choices":["December"],
        "correctAnswer":0,
},
{
        "title":"Which is the first month of the year?",
        "choices":["January"],
        "correctAnswer":0,
},
{
        "title":"After which Islamic month eid is celebrated?",
        "choices":["Ramadan"],
        "correctAnswer":0,
},
{
        "title":"What is the sum of 6 and 8?",
        "choices":["14"],
        "correctAnswer":0,
},
{
        "title":"Where do we get oxygen from?",
        "choices":["Plants and Trees"],
        "correctAnswer":0,
},
{
        "title":"Your Father’s mother will be your",
        "choices":["Grandmother"],
        "correctAnswer":0,
},
{
        "title":"Who makes the wooden furniture?",
        "choices":["Carpenter"],
        "correctAnswer":0,
},
{
        "title":".  How many days are there is February?",
        "choices":["28, 29 in a leap year"],
        "correctAnswer":0,
},
{
        "title":"Name a red color vegetable?",
        "choices":["Tomato"],
        "correctAnswer":0,
},
{
        "title":"How many emirates are there in UAE?",
        "choices":["Seven"],
        "correctAnswer":0,
},
{
        "title":"How many Millilitres makes one litre?",
        "choices":["1000"],
        "correctAnswer":0,
},
{
        "title":"How many grams makes 1 kilogram?",
        "choices":["1000 gram"],
        "correctAnswer":0,
},
{
        "title":"How many times does Muslim pray in a day?",
        "choices":["5"],
        "correctAnswer":0,
},
{
        "title":"What are the five pillars of Islam?",
        "choices":["Faith, Prayers, Alms, fasting, pilgrimage"],
        "correctAnswer":0,
},
{
        "title":"In which Hijri month is eid ul fitr celebrated?",
        "choices":["Shawwal"],
        "correctAnswer":0,
},
{
        "title":"In which Hijri month is eid Al Adha is celebrated?",
        "choices":["Dhul Hijjah"],
        "correctAnswer":0,
},
{
        "title":"If you mix red and yellow color, which color you will get?",
        "choices":["Orange"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Saudi Arabia?",
        "choices":["Riyadh"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Oman?",
        "choices":["Muscat"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Bahrain?",
        "choices":["Al Manama"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city of Kuwait?",
        "choices":["Kuwait City"],
        "correctAnswer":0,
},
{
        "title":"What is the capital city Qatar?",
        "choices":["Doha"],
        "correctAnswer":0,
},
{
        "title":"Which of these lays egg: hen, cat, dog",
        "choices":["Hen"],
        "correctAnswer":0,
},
{
        "title":"Which organ helps us to see?",
        "choices":["Eyes"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to walk?",
        "choices":["Legs"],
        "correctAnswer":0,
},
{
        "title":"Which month comes after July?",
        "choices":["August"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to write?",
        "choices":["Hand"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to listen?",
        "choices":["Ears"],
        "correctAnswer":0,
},
{
        "title":"Which body part helps us to smell?",
        "choices":["Nose"],
        "correctAnswer":0,
},
{
        "title":"Which one of these is a domestic animal? Cat, zebra, Giraffe",
        "choices":["Cat"],
        "correctAnswer":0,
},
{
        "title":"Which doctor do we visit when we have problem in our teeth?",
        "choices":["Dentist"],
        "correctAnswer":0,
},
{
        "title":"1. In which direction does the sunrise?",
        "choices":["East"],
        "correctAnswer":0,
},
{
        "title":"How many zeros are there in one hundred thousand?",
        "choices":["5"],
        "correctAnswer":0,
},
{
        "title":"How many hours are there in two days?",
        "choices":["48 hours (24+24)"],
        "correctAnswer":0,
},
{
        "title":"How many months of the year have 31 days?",
        "choices":["7 (January, March, May, July, August, October and December)"],
        "correctAnswer":0,
},
{
        "title":"How many weeks are there in one year?",
        "choices":["52"],
        "correctAnswer":0,
},
{
        "title":"Which are the colors in a rainbow?",
        "choices":["Violet, Indigo, Blue, Green, Yellow, Orange, Red"],
        "correctAnswer":0,
},
{
        "title":"How many bones does an adult human have?",
        "choices":["206"],
        "correctAnswer":0,
},
{
        "title":"Who was the first man to walk on the moon?",
        "choices":["Neil Amstrong"],
        "correctAnswer":0,
},
{
        "title":"How many millimeters are there in 1cm?",
        "choices":["10mm"],
        "correctAnswer":0,
},
{
        "title":"Which is the nearest star to planet earth?",
        "choices":["Sun"],
        "correctAnswer":0,
},
{
        "title":"Which is the longest river on the earth?",
        "choices":["Nile"],
        "correctAnswer":0,
},
{
        "title":"Which is the principal source of energy for earth?",
        "choices":["Sun"],
        "correctAnswer":0,
},
{
        "title":"How many lungs does the human body have?",
        "choices":["Two"],
        "correctAnswer":0,
},
{
        "title":"What is the standard taste of the water?",
        "choices":["Water is tasteless"],
        "correctAnswer":0,
},
{
        "title":"Which is the tallest mountain in the world?",
        "choices":["Mount Everest"],
        "correctAnswer":0,
},
{
        "title":"Which continent is known as ‘Dark’ continent?",
        "choices":["Africa"],
        "correctAnswer":0,
},
{
        "title":"Which planet is known as the Red Planet?",
        "choices":["Mars","Jupiter","Venus","Earth"],
        "correctAnswer":0,
},
{
        "title":"Which is the most sensitive organ in our body?",
        "choices":["Skin"],
        "correctAnswer":0,
},
{
        "title":"Which day is observed as World Environment Day?",
        "choices":["5 June"],
        "correctAnswer":0,
},
{
        "title":"How many years are there in a century?",
        "choices":["100"],
        "correctAnswer":0,
},
{
        "title":"Who invented the Computer?",
        "choices":["Charles Babbage"],
        "correctAnswer":0,
},
{
        "title":"How many players are there in a cricket team?",
        "choices":["11"],
        "correctAnswer":0,
},
{
        "title":"Which day is observed as World Literacy Day?",
        "choices":["8 September"],
        "correctAnswer":0,
},
{
        "title":"Which is the principal source of energy for earth?",
        "choices":["Sun"],
        "correctAnswer":0,
},
{
        "title":"Who is the inventor of Radio?",
        "choices":["Marconi"],
        "correctAnswer":0,
},
{
        "title":"Which place is known as the roof of the world?",
        "choices":["Tibet"],
        "correctAnswer":0,
},
{
        "title":"How many teeth does a healthy adult have including the wisdom teeth?",
        "choices":["32"],
        "correctAnswer":0,
},
{
        "title":"Which gas is most abundant in the earth’s atmosphere?",
        "choices":["Nitrogen"],
        "correctAnswer":0,
},
{
        "title":"Which is the continent with the most number of countries?",
        "choices":["Africa"],
        "correctAnswer":0,
},
{
        "title":"How many planets are there in our solar system?",
        "choices":["8"],
        "correctAnswer":0,
},
{
        "title":"Which is the hottest continent on Earth?",
        "choices":["Africa"],
        "correctAnswer":0,
},
{
        "title":"Which is the smallest continent in the world?",
        "choices":["Australia"],
        "correctAnswer":0,
},
{
        "title":"How many years are there in a millennium?",
        "choices":["1000"],
        "correctAnswer":0,
},
{
        "title":"Which country is home to the kangaroo?",
        "choices":["Kangaroo"],
        "correctAnswer":0,
},
{
        "title":"Who painted the Mona Lisa?",
        "choices":["Leonardo Da Vinci"],
        "correctAnswer":0,
},
{
        "title":"Who invented the telephone?",
        "choices":["Alexander Graham Bell"],
        "correctAnswer":0,
},
{
        "title":"What does the Internet prefix WWW stand for?",
        "choices":["World Wide Web"],
        "correctAnswer":0,
},
{
        "title":"How much of Earth’s surface is covered by ocean?",
        "choices":["71%"],
        "correctAnswer":0,
},
{
        "title":"Who discovered Penicillin in 1928?",
        "choices":["Alexander Fleming"],
        "correctAnswer":0,
},
{
        "title":"What is the sum of 5+2?",
        "choices":["7","8","9","6"],
        "correctAnswer":0,
},
{
        "title":"What farm animal gives us milk to drink?",
        "choices":["Hen","Cow","Dog","Chicken"],
        "correctAnswer":1,
},
{
        "title":"Johnny had five pumpkins and he made two Jack-O-Lanterns. Out of the five, how many would there be left without a face?",
        "choices":["0","2","3","5"],
        "correctAnswer":2,
},
{
        "title":"5+5= what?",
        "choices":["0","8","10","5"],
        "correctAnswer":2,
},
{
        "title":" If you wanted to dig a hole, which of the following would you be most likely to use?",
        "choices":["Hoe","spade","hammer","nail"],
        "correctAnswer":1,
},
{
        "title":" On a clock, if the big hand is on 12 and the little hand is on 3 what time would it be?",
        "choices":["3'o clock","5'o clock","2'o clock","4'o clock"],
        "correctAnswer":0,
},
{
        "title":" If an average person counted all of their fingers and toes, how many would they have?",
        "choices":["24","20","28","19"],
        "correctAnswer":1,
},
{
        "title":" What colors would you use to make the color purple?",
        "choices":["Red and pink","pink and yellow","red and blue","blue and pink"],
        "correctAnswer":2,
},
{
        "title":" What is 10-2?",
        "choices":["6","7","5","8"],
        "correctAnswer":3,
},
{
        "title":" What vehicle runs on a track and blows a whistle?",
        "choices":["train","helicopter","Aeroplane","Car"],
        "correctAnswer":0,
},
{
        "title":" What holds school supplies and children also carry them on their backs?",
        "choices":["paper bag","Box","school bag","Purse"],
        "correctAnswer":0,
},
];